import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const NO_RETRY_PATHS = [
  "/auth/login",
  "/auth/refresh",
  "/auth/forgot-password",
  "/auth/reset-password",
  "/auth/change-password",
];

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const orig = error.config;
    if (
      error.response?.status === 401 &&
      orig &&
      !orig._retry &&
      !NO_RETRY_PATHS.some((p) => orig.url.includes(p))
    ) {
      orig._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch (e) {
        // refresh failed; reject original error
      }
    }
    return Promise.reject(error);
  }
);

export const API_URL = api.defaults.baseURL;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return err?.message || "Something went wrong. Please try again.";
}

export default api;
